<template>
	<b-navbar toggleable class="erco-dashboard-headbar p-0">
		<b-nav-toggle target="nav-collapse"></b-nav-toggle>
		<!--<b-link class="navbar-brand" to="#">-->
		<div class="navbar-brand">
			<p class="navbar-brand mb-0 pb-0 pt-0">ERCO <span class="text-warning">LSP</span></p>
		</div>
		<b-collapse is-nav id="nav-collapse">
			<b-nav is-nav-bar class="ml-auto">

				<b-nav-item-dropdown class="help-dropdown mr-sm-4" text="Hilfe">

					<b-dropdown-item>
						<a @click.stop="" href="https://ercowiki.klickmeister.org/mediawiki/index.php/ERCO:LSP4">Dokumentation</a> Zugangsdaten: erco:dvdda
					</b-dropdown-item>
					<b-dropdown-item>
						weitere Fragen und Ideen bitte an <a @click.stop="" href="mailto:lsp@klickmeister.de">lsp@klickmeister.de</a>
					</b-dropdown-item>

				</b-nav-item-dropdown>
				<b-nav-item-dropdown class="mr-sm-4" :text="username" right-alignment>
					<!--<b-dropdown-item>Profile</b-dropdown-item>-->
					<b-dropdown-item @click="handleSignoutClick">Signout</b-dropdown-item>
				</b-nav-item-dropdown>


			</b-nav>
			<b-form-input type="text"
			              class="search-input"
			              placeholder="Suchbegriff"
			              v-model="searchString">
			 </b-form-input>
			<!--<b-button class="my-2 my-sm-0 ml-sm-2">Suchen</b-button>-->
		</b-collapse>
	</b-navbar>
</template>
<script>
	import ErcoDropdown from '@/components/molecules/ErcoDropdown';

	export default {
		name: 'ErcoDashboardHeaderbarOrganism',
		data() {
			return {
				searchString: (() => (this.$store.state.dashboard.searchString))(),
				timeoutHandler: null,
			};
		},
		props: {
		},
		computed: {
			username() {
				return this.$store.state.user.username;
			},
		},
		watch: {
			searchString() {
				clearTimeout(this.timeoutHandler);
				this.timeoutHandler = setTimeout(() => {
					this.$store.dispatch('updateSearchString', { searchString: this.searchString });
				}, 500);
			},
		},
		methods: {
			handleSignoutClick() {
				this.$router.push({ path: '/logout', query: {} });
			},
		},
		components: {
			ErcoDropdown,
		},
	};
</script>

<style lang="scss">

	.erco-dashboard-headbar {
		#nav-collapse {
			.help-dropdown {
				.dropdown-menu {
					.dropdown-item {
						&:hover,
						&.active {
							a {
								color: white;
							}
						}
					}
				}
			}
		}

		.search-input {
			width: 12rem;
		}
	}
</style>



// WEBPACK FOOTER //
// ErcoDashboardHeadbar.vue?5b95f74c